/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/naming-convention */
import { useState, useEffect } from 'react';
import RequestingProviderModal from './requestingprovidermodal.component';
import { usePADomainModel } from '../../context/ctxPriorAuthorizationDomain';
import './requestingprovider.component.css';

export type requestingproviderprops = {
  taxId: string,
  cpfId: string,
  npi: string,
  lastName: string,
  firstName: string,
  groupName: string,
  facilityName:string,
  address: string,
  address2: string,
  city: string,
  state: string,
  zipCode: string,
  phone: string,
  name:string
};

interface requestingproviderdetailProps {
  requestingprovider: requestingproviderprops
  setRequestingProviderValues: (requestingproviderValues: any) => any
  index : number,
  cignaManaged: boolean
}

const RequestingProvider : React.FC<requestingproviderdetailProps> = ({ requestingprovider, setRequestingProviderValues, index, cignaManaged }) => {
  const { updateRequestingProvider } = usePADomainModel();

  const [requestingProviderModalIsOpen, setRequestingProviderModalIsOpen] = useState(false);
  const [requestingProviderdetail, setRequestingProviderdetail] = useState<requestingproviderprops>(requestingprovider);
  const [displayValue, setdisplayValue] = useState('');
  const [error, setError] = useState('');
  const { updateRequestingProviderValidationStatus } = usePADomainModel();

  const openRequestingProviderModal = () => {
    setRequestingProviderModalIsOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setRequestingProviderModalIsOpen(false); document.body.style.overflow = '';
  };

  useEffect(() => {
    if (!cignaManaged) {
      updateRequestingProviderValidationStatus((index + 1).toString(), true);
      setError('');
    } else {
      setRequestingProviderValues(requestingProviderdetail);
      if (requestingProviderdetail.facilityName) {
        setdisplayValue(requestingProviderdetail.facilityName);
        updateRequestingProviderValidationStatus((index + 1).toString(), true);
        setError('');
      } else if (requestingProviderdetail.groupName) {
        setdisplayValue(requestingProviderdetail.groupName);
        updateRequestingProviderValidationStatus((index + 1).toString(), true);
        setError('');
      } else if (requestingProviderdetail.lastName !== '' || requestingProviderdetail.firstName !== '') {
        setdisplayValue(`${requestingProviderdetail.firstName} ${requestingProviderdetail.lastName}`);
        updateRequestingProviderValidationStatus((index + 1).toString(), true);
        setError('');
      } else {
        updateRequestingProviderValidationStatus((index + 1).toString(), false);
        setError('Please complete requesting provider details');
      }
      updateRequestingProvider(index, requestingProviderdetail);
    }
  }, [requestingProviderdetail]);

  return (
    <>
      <p className="fw-bold mb-0">Requesting Provider</p>
      {error && (<div className="rpErrorMessage" data-testid={`rpErrorMessage-${index}`}>{error}</div>)}
      <p className="pl-4 mb-1 rp-name" id="requesting-provider-2">
        {displayValue}
      </p>
      <div className="FieldNote mb-1">
        <div className="Fieldnotebase">
          <div className="font-size-sm" />
        </div>
      </div>
      <div>
        <button type="button" className="btn btn-outline-primary rounded-pill mr-2 px-3" onClick={() => { openRequestingProviderModal(); }}>Edit</button>
      </div>
      {requestingProviderModalIsOpen && <RequestingProviderModal item={requestingProviderdetail} setrequestingProviderItem={setRequestingProviderdetail} onClose={closeModal} />}

    </>
  );
};

export default RequestingProvider;
